import { api } from './client';
import type {
  AdminUser,
  CreateUserRequest,
  UpdateUserRequest,
  ActivateLicenseRequest,
  ExtendLicenseRequest,
  ListUsersResponse,
  GetUserDetailResponse,
  CreateUserResponse,
  LicenseOperationResponse,
} from '@affogato/shared';

export const adminApi = {
  // User management
  listUsers: () => api.get<ListUsersResponse>('/admin/users'),

  getUser: (id: string) => api.get<GetUserDetailResponse>(`/admin/users/${id}`),

  createUser: (data: CreateUserRequest) =>
    api.post<CreateUserResponse & { message: string }>('/admin/users', data),

  updateUser: (id: string, data: UpdateUserRequest) =>
    api.put<{ success: boolean; message: string }>(`/admin/users/${id}`, data),

  deleteUser: (id: string) =>
    api.delete<{ success: boolean; message: string }>(`/admin/users/${id}`),

  // License management
  activateLicense: (data: ActivateLicenseRequest) =>
    api.post<LicenseOperationResponse>('/admin/licenses/activate', data),

  // Alias for activateLicense - used for inline editing
  updateLicense: (data: ActivateLicenseRequest) =>
    api.post<LicenseOperationResponse>('/admin/licenses/activate', data),

  extendLicense: (data: ExtendLicenseRequest) =>
    api.post<LicenseOperationResponse>('/admin/licenses/extend', data),

  cancelLicense: (userId: string) =>
    api.post<LicenseOperationResponse>(`/admin/licenses/cancel/${userId}`),

  downgradeLicense: (userId: string) =>
    api.post<LicenseOperationResponse>(`/admin/licenses/downgrade/${userId}`),
};

// Types for local use
export type { AdminUser };
